export const getToken: () => string | null = () =>
  localStorage.getItem('token');

export const setToken: (token: string) => void = (token) =>
  localStorage.setItem('token', token);

export const hasToken: () => boolean = () => !!getToken();

export const unsetToken: () => void = () => localStorage.removeItem('token');
